export default __webpack_public_path__ + "static/media/device-models-phone-large.e80b3ddb.jpg";